import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAuth } from "../auth/AuthProvider";
import logoImage from "../assets/images/logo.png";
import aisImage from "../assets/images/ais_mamman.png";
import { getProducts } from "../features/product";
import AuthModal from "../components/AuthModal";
import Stepper from "../components/Stepper"; // ✅ Added

const StepperHeader = ({ currentStep }) => {  // ✅ Accept prop
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const { products, status } = useSelector((state) => state.product);
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const { modalIsOpen, setModalIsOpen } = useAuth();
    const ASSET_BASE = process.env.REACT_APP_CURRENT_ENV || "";

    const navigate = useNavigate();
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        document.body.dir = lng === "ar" ? "rtl" : "ltr";
        localStorage.setItem("language", lng);

        const linkElement = document.getElementById("dynamic-stylesheet");

        if (lng === "ar") {
            linkElement.href = `${ASSET_BASE}/rtl.css`;
        } else {
            linkElement.href = `${ASSET_BASE}/ltr.css`;
        }
    };

    useEffect(() => {
        const linkElement = document.getElementById("dynamic-stylesheet");
        const savedLanguage = localStorage.getItem("language") || "en";

        i18n.changeLanguage(savedLanguage);
        document.body.dir = savedLanguage === "ar" ? "rtl" : "ltr";

        if (savedLanguage === "ar") {
            linkElement.href = `${ASSET_BASE}/rtl.css`;
        } else {
            linkElement.href = `${ASSET_BASE}/ltr.css`;
        }
    }, [i18n, status]);

    const handleCloseOffcanvas = () => {
        setShowOffcanvas(false);
    };

    const handleShowOffcanvas = () => setShowOffcanvas(true);

    const handleNavigation = (path) => {
        navigate(path);
        handleCloseOffcanvas();
    };

    const handleProductNavigation = (path, index) => {
        if (products && products.length) {
            localStorage.setItem(
                "product_details",
                JSON.stringify({
                    product_id: products[index]?.id,
                    sub_product_id: products[index]?.sub_products[0]?.id,
                })
            );
        }
    };

    const [brandWidth, setBrandWidth] = useState("50%");

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setBrandWidth("40%");
            } else if (window.innerWidth < 992) {
                setBrandWidth("20%");
            } else if (window.innerWidth < 1500) {
                setBrandWidth("40%");
            } else {
                setBrandWidth("19%");
            }
        };

        handleResize(); // run on load
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        dispatch(getProducts());
    }, [dispatch]);

    useEffect(() => {
        if (modalIsOpen) {
            handleCloseOffcanvas();
        }
    }, [modalIsOpen]);

    return (
        <>
            <header className="header pb-3 px-4 mx-3">
                <Navbar expand="lg">
                    <Container
                        fluid
                        className="d-flex flex-column flex-lg-row align-items-center position-relative"
                    >
                        {/* TOP ROW (Logo + Toggle) */}
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            {/* LEFT — Logo */}
                            <Navbar.Brand
                                style={{ cursor: "pointer", display: "flex", width: brandWidth }}>
                                <img
                                    src={aisImage}
                                    alt="logo"
                                    // className="img-fluid"
                                    style={{ height: "auto" }}
                                    onClick={() => navigate("/")}
                                />
                                <a
                                    className="language-btn"
                                    onClick={() =>
                                        currentLanguage === "en"
                                            ? changeLanguage("ar")
                                            : changeLanguage("en")
                                    }
                                >
                                    {currentLanguage === "en" ? t("arabic") : t("english")}
                                </a>
                            </Navbar.Brand>

                            {/* RIGHT — Toggle */}
                            <Navbar.Toggle onClick={handleShowOffcanvas} />
                        </div>

                        {/* DESKTOP CENTERED STEPPER */}
                        {currentStep && (
                            <div
                                className="hide-on-small"
                                style={{
                                    position: "absolute",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    width: "40%",
                                }}
                            >
                                <Stepper currentStep={currentStep} />
                            </div>
                        )}

                        {/* MOBILE STEPPER (Full Width Below) */}
                        {currentStep && (
                            <div className="show-on-small w-100 mt-3">
                                <Stepper currentStep={currentStep} />
                            </div>
                        )}

                        {/* OFFCANVAS */}
                        <Navbar.Offcanvas
                            show={showOffcanvas}
                            onHide={handleCloseOffcanvas}
                            placement={currentLanguage === "ar" ? "end" : "start"}
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title>{t("menu")}</Offcanvas.Title>
                            </Offcanvas.Header>

                            <Offcanvas.Body>
                                <Nav className="flex-grow-1">
                                    <Nav.Link
                                        className="text-nowrap"

                                        onClick={() => handleNavigation("/")}>
                                        {t("navbar.home")}
                                    </Nav.Link>

                                    <Nav.Link
                                        className="text-nowrap"
                                        onClick={() => handleNavigation("/about")}
                                    >
                                        {t("navbar.about_us")}
                                    </Nav.Link>


                                    <NavDropdown
                                        title={t("insurance")}
                                        show={show}
                                        onMouseEnter={() => setShow(true)}
                                        onMouseLeave={() => setShow(false)}
                                    >
                                        {products?.map((product, index) => (
                                            <NavDropdown.Item
                                                key={index}
                                                onClick={() =>
                                                    handleProductNavigation(
                                                        `/${product.product_name.replaceAll(" ", "-")}`,
                                                        index
                                                    )
                                                }
                                                href={`${product.product_name.replaceAll(
                                                    " ",
                                                    "-"
                                                )}`}
                                            >
                                                {currentLanguage === "ar"
                                                    ? product?.product_name_ar
                                                    : product?.product_name
                                                        ? product.product_name.charAt(0).toUpperCase() +
                                                        product.product_name.slice(1)
                                                        : ""}
                                            </NavDropdown.Item>
                                        ))}
                                    </NavDropdown>

                                    <Nav.Link
                                        className="text-nowrap"
                                        onClick={() => handleNavigation("/contact")}
                                    >
                                        {t("navbar.contact_us")}
                                    </Nav.Link>
                                </Nav>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            </header>

            {modalIsOpen && (
                <AuthModal
                    modalIsOpen={modalIsOpen}
                    setModalIsOpen={setModalIsOpen}
                />
            )}
        </>
    );
};

export default StepperHeader;